export default () => ({
  open: false,
  heightSet: false,
  showLoading: false,
  index: 1,
  currentProduct: null,
  sizeOptionText: null,
  selectedVariants: [],
  productAmount: null,

  hide() {
    this.open = false;
    this.index = 1;
    this.currentProduct = 1;
    this.selectedVariants = [];
    this.$dispatch("set-index", 1);
  },

  show() {
    this.currentProduct = `product-${this.index}`;

    let body = document.querySelector("body");
    this.open = true;
    this.$refs.shopTheLook.style.maxHeight = "1200px";
  },

  switchProduct(next) {
    if (next) {
      this.index++;
    } else {
      this.index--;
    }

    this.$dispatch("set-index", this.index);
    this.currentProduct = `product-${this.index}`;
  },

  addProductsToCart(details) {
    let image = details.image;
    let productAmount = details.productAmount;
    let title = details.title;
    let variantList = [];
    this.productAmount = productAmount;

    for (let i = 0; i < this.selectedVariants.length; i++) {
      let prodObj = {
        id: this.selectedVariants[i][0],
        quantity: 1,
      };
      variantList.push(prodObj);
    }
    variantList.reverse();

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: variantList }),
    })
      .then((response) => {
        this.hide();
        this.$dispatch("cart-updated");
        this.$dispatch("cart-notice-multiple", {
          image: image,
          title: title,
          amount: variantList.length,
        });
        return response.json();
      })
      .then((response) => {
        const items = response.items;
        if (Tracking && Array.isArray(items) && items.length) {
          items.forEach((item) => {
            const variant = Tracking.transformVariant(item);
            if (variant) {
              Tracking.addToCart(variant);
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  updateSelectedVariants(idList) {
    if (this.selectedVariants.length >= 1) {
      for (let i = 0; i < this.selectedVariants.length; i++) {
        if (this.selectedVariants[i][1] == idList[1]) {
          this.selectedVariants[i][0] = idList[0];
          break;
        } else {
          this.selectedVariants.push(idList);
          break;
        }
      }
    } else {
      this.selectedVariants.push(idList);
    }
  },

  removeSelectedVariants(idList) {
    if (this.selectedVariants.length >= 1) {
      for (let i = 0; i < this.selectedVariants.length; i++) {
        if (this.selectedVariants[i][1] == idList[1]) {
          this.selectedVariants.splice(i, 1);
          break;
        }
      }
    }
  },

  toggleBodyClass(addBodyClass) {
    let body = document.querySelector("body");
    if (addBodyClass) {
      if (!body.classList.contains("modal-open")) {
        body.classList.add("modal-open");
      }
    } else {
      body.classList.remove("modal-open");
    }
  },

  setHeight() {
    let offset = Alpine.store("quickShopSource").source ? 52 : 22;
    this.$refs.shopTheLook.style.height = `${
      this.$refs.quickAddInfo.offsetHeight + offset
    }px`;
  },
});
